import React, { useEffect, useState } from "react";

/**
 * GLOBAL SWITCH
 * Flip this to true after ad approval
 */
const ADS_ENABLED = false;

const WaldoAd = ({ type }) => {
  // Define AdSense and NeworMedia slots for each type
  const squareAds = [
    { network: "adsense", slot: "111111" },
    { network: "newormedia", slot: "waldo-tag-42186" },
  ];

  const horizontalAds = [
    { network: "adsense", slot: "111111" },
    { network: "newormedia", slot: "waldo-tag-42187" },
  ];

  const verticalAds = [
    { network: "adsense", slot: "222222" },
    { network: "newormedia", slot: "waldo-tag-42188" },
  ];

  const getAdList = () => {
    if (type === "square") return squareAds;
    if (type === "horizontal") return horizontalAds;
    if (type === "vertical") return verticalAds;
    return squareAds;
  };

  const ads = getAdList();
  const [index, setIndex] = useState(0);
  const ad = ads[index];

  // Rotate ads every 30 seconds (only when ads enabled)
  useEffect(() => {
    if (!ADS_ENABLED) return;

    const change = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 30000);

    return () => clearInterval(change);
  }, [ads.length]);

  // Trigger ad rendering scripts (only when ads enabled)
  useEffect(() => {
    if (!ADS_ENABLED) return;

    try {
      if (ad.network === "adsense") {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } else if (ad.network === "newormedia") {
        window.waldo = window.waldo || [];
        window.waldo.push({});
      }
    } catch (err) {
      console.error("Ad render error:", err);
    }
  }, [ad]);

  // Render the ad element
  const renderAd = () => {
    if (!ADS_ENABLED) return null;

    if (ad.network === "adsense") {
      return (
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-5053752584555303"
          data-ad-slot={ad.slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      );
    }

    if (ad.network === "newormedia") {
      return <div id={ad.slot}></div>;
    }

    return null;
  };

  // Final render (nothing shown when ads are disabled)
  if (!ADS_ENABLED) {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        margin: "10px 0",
        minHeight: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {renderAd()}
    </div>
  );
};

export default WaldoAd;